import { render, staticRenderFns } from "./ChildrenTest.vue?vue&type=template&id=1b36dcc0&scoped=true&"
import script from "./ChildrenTest.vue?vue&type=script&lang=js&"
export * from "./ChildrenTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36dcc0",
  null
  
)

export default component.exports